import { getDocumentFields, rootUrl } from 'utils/helper';
import { getBreadcrumbs } from 'utils/breadcrumbs';
import { useFetchPageQuery } from 'redux/apis/page';

export default function useProps({
  type,
  contentModules: ssrContentModules,
  metaData: metaFromProps,
  ...rest
}) {
  const { data = {}, isLoading } = useFetchPageQuery(type, { skip: Boolean(ssrContentModules) });
  const contentModules = ssrContentModules ?? data.contentModules ?? [];
  const metaData = metaFromProps ?? data.metaData ?? {};

  const textModule = contentModules[0] || {};

  const { text } = getDocumentFields(textModule, ['text']);

  const breadcrumbs = getBreadcrumbs(type);

  const pageMetadata = {
    ...metaData,
    url: `${rootUrl}/${type}`,
  };

  const { sys: { updatedAt } = {} } = textModule;

  return {
    updatedAt,
    breadcrumbs,
    pageMetadata,
    text,
    type,
    ...rest,
  };
}
